import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IconoirXmark } from '@ey-xd/motif-icon';
import { ButtonSizes, MOTIF_MODAL_DATA, MotifButtonModule, MotifIconModule, MotifModalModule } from '@ey-xd/ng-motif';

@Component({
  selector: 'app-long-text-modal',
  standalone: true,
  imports: [MotifModalModule, MotifButtonModule, MotifIconModule],
  templateUrl: './long-text-modal.component.html',
  styleUrl: './long-text-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LongTextModalComponent {
  #config: LongTextModalConfig = inject(MOTIF_MODAL_DATA);

  readonly icon = IconoirXmark;
  readonly buttonSizes = ButtonSizes;

  public get title(): string {
    return this.#config.title;
  }

  public get text(): string {
    return this.#config.text;
  }
}

export class LongTextModalConfig {
  public constructor(
    public title: string,
    public text: string
  ) {}
}
